import * as React from "react";
import { SVGProps } from "react";

const Heart = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.736 4.657c-2.079 0-4.236 1.88-4.236 4.514 0 3.107 2.324 5.96 4.861 8.12a29.65 29.65 0 0 0 4.566 3.175l.073.041.073-.04c.271-.153.661-.38 1.13-.674.94-.588 2.19-1.441 3.436-2.502 2.537-2.16 4.861-5.013 4.861-8.12 0-2.634-2.157-4.514-4.236-4.514-2.106 0-3.801 1.389-4.553 3.643a.75.75 0 0 1-1.422 0c-.752-2.254-2.447-3.643-4.553-3.643ZM12 21.36l.343.667a.75.75 0 0 1-.686 0L12 21.36ZM1 9.17C1 5.71 3.829 3.158 6.736 3.158c2.294 0 4.145 1.226 5.264 3.105 1.12-1.879 2.97-3.105 5.264-3.105C20.17 3.157 23 5.709 23 9.171c0 3.818-2.801 7.06-5.389 9.262a31.158 31.158 0 0 1-5.233 3.576l-.025.013-.007.003-.002.001L12 21.36l-.343.667-.003-.002-.007-.003-.025-.013A29.426 29.426 0 0 1 10 21.065a31.16 31.16 0 0 1-3.611-2.632C3.8 16.23 1 12.99 1 9.171Z"
    />
  </svg>
);

export default Heart;
